import Player from '@vimeo/player'

class VideoLightbox {
  constructor (element) {
    this.element = element
    this.container = element.querySelector('.video-lightbox-container')
    this.videoIframe = element.querySelector('.video-lightbox-video iframe')
    this.player = new Player(this.videoIframe)

    document.body.appendChild(element) // Move dialog to the end of body
    element.addEventListener('click', (event) => {
      event.preventDefault()
      this.close()
    })
    this.container.addEventListener('click', (event) => {
      // Stop propagation so that clicking within the container does not close the dialog
      event.stopPropagation()
    })

    this.closeButton = this.container.querySelector('.video-lightbox-close')
    this.closeButton.addEventListener('click', (event) => {
      event.preventDefault()
      this.close()
    })
  }

  open () {
    // Make lightbox visible
    this.element.classList.add('video-lightbox-visible')
    // Focus on close button
    this.closeButton.focus()
    // Capture keys to allow lightbox to be closed with escape
    document.body.addEventListener('keydown', this.onKeydown, true)
    // Play
    this.player.play().then(() => {
      // The video has started playing
    }).catch((error) => {
      // The video could not start playing
    })
  }

  close () {
    // Stop capturing keys
    document.body.removeEventListener('keydown', this.onKeydown, true)
    // Hide lightbox
    this.element.classList.remove('video-lightbox-visible')
    // Pause video and reset the time
    this.player.pause().then(() => {
      this.player.setCurrentTime(0).then(() => {
        // The current time has been reset
      }).catch((error) => {
        // Could not reset time, so we reload the iframe as fallback
        this.videoIframe.src = this.videoIframe.src
      })
    }).catch((error) => {
      // Could not pause video, so we reload the iframe as fallback
      this.videoIframe.src = this.videoIframe.src
    })
  }

  onKeydown = (event) => {
    if (event.key === 'Escape') {
      this.close()
    }
  }
}

window.addEventListener('cmpb-layout-loaded', function (event) {
  var VideoLightboxBlocks = event.layout.querySelectorAll('.cmpb-block-video-lightbox')
  for (let i = 0, l = VideoLightboxBlocks.length; i < l; i++) {
    let block = VideoLightboxBlocks[i]
    let lightbox = new VideoLightbox(block.querySelector('.video-lightbox'))
    const thumbnail = block.querySelector('.video-lightbox-thumbnail')
    thumbnail.addEventListener('click', (event) => {
      event.preventDefault()
      lightbox.open()
    })
    thumbnail.href = thumbnail.dataset.href
  }
})
